import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { DefaultButton, IPanelStyles, List, MessageBar, MessageBarType, Panel, PanelType, PrimaryButton, IMessageBarProps } from '@fluentui/react';
import { useBoolean } from '@fluentui/react-hooks';
import { IField, ITextField } from '../../shared/interfaces';
import AppUtilities from '../../shared/Utilities/appUtilities';
import { RootState } from '../../store';
import IndicePAForm from './IndicePAForm';

const queryString = require('query-string');
export interface IndicePAPanelProps {
    extraCssClass?: string
    indicePAPanelIsOpen: boolean
    onIndicePADismiss: () => void

}

type Props = IndicePAPanelProps & RouteComponentProps

const IndicePAPanel: React.FunctionComponent<Props> = (props) => {

    let [panelIsOpen, { setTrue: openIndicePAPanel, setFalse: dismissIndicePAPanel }] = useBoolean(props.indicePAPanelIsOpen);

    let [messageBarIsVisible, { setTrue: showMessageBar, setFalse: dismissMessageBar }] = useBoolean(false);
    let [errorMessageProps, setErrorMessageProps] = useState<IMessageBarProps>({})

    const indicePAPanelDismiss = () => {


        props.onIndicePADismiss();
    }

    const onRenderFooterContent = () => {
        return (
            <React.Fragment>
                <DefaultButton
                    onClick={indicePAPanelDismiss}
                    text="Chiudi"
                />
            </React.Fragment>
        );
    }

    const onError = (errorMessageProps: IMessageBarProps) => {
        showMessageBar();
        setErrorMessageProps(errorMessageProps)
    }
    return (
        <Panel
            key='indicePAPanel'

            isLightDismiss
            isOpen={panelIsOpen}
            type={PanelType.custom}
            customWidth={'600px'}
            headerText="Indice PA"
            focusTrapZoneProps={{
                isClickableOutsideFocusTrap: true,
                forceFocusInsideTrap: true,
            }}
            onDismiss={indicePAPanelDismiss}
            onRenderFooterContent={onRenderFooterContent}
            // Stretch panel content to fill the available height so the footer is positioned
            // at the bottom of the page
            isFooterAtBottom={false}

        >
            {
                messageBarIsVisible &&
                <MessageBar {...errorMessageProps}
                    onDismiss={dismissMessageBar}
                    dismissButtonAriaLabel="Close" />
            }
            {/*<div className={"flex flex-column position-relative overflow-hidden"}>*/}

            {/*    <ScrollPanel style={{ width: '100%', height: '100%' }} className="custom-scroll-bar">*/}

                    <IndicePAForm onError={onError} />


            {/*    </ScrollPanel>*/}
            {/*</div>*/}



        </Panel>

    );
}

export default IndicePAPanel;
